"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import AppLogo from "@/components/ui/AppLogo";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Facilities", href: "#facilities" },
    { label: "About", href: "#about" },
    { label: "Gallery", href: "#gallery" },
    { label: "Membership", href: "#membership" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 transition-all duration-500"
      style={{
        background: scrolled
          ? "rgba(15, 31, 61, 0.95)"
          : "transparent",
        backdropFilter: scrolled ? "blur(20px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.06)" : "none",
      }}
    >
      <nav className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link href="/homepage" className="flex items-center gap-3">
          <AppLogo size={40} />
          <div className="flex flex-col leading-none">
            <span
              className="font-bold text-lg tracking-tight text-white"
              style={{ letterSpacing: "-0.02em" }}
            >
              Play
              <span style={{ color: "var(--terracotta)" }}>.XP</span>
            </span>
            <span
              className="text-white/40 font-medium"
              style={{ fontSize: "0.55rem", letterSpacing: "0.25em", textTransform: "uppercase" }}
            >
              Elite Sports
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a key={link?.href} href={link?.href} className="nav-link">
              {link?.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-4">
          <a href="#contact" className="btn-secondary" style={{ padding: "0.6rem 1.4rem", fontSize: "0.75rem" }}>
            <span>Book Session</span>
          </a>
          <a href="#membership" className="btn-primary pulse-cta" style={{ padding: "0.6rem 1.4rem", fontSize: "0.75rem" }}>
            <span>Join Now</span>
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span
            className="block w-6 h-0.5 bg-white transition-all duration-300"
            style={{ transform: mobileOpen ? "rotate(45deg) translateY(8px)" : "none" }}
          />
          <span
            className="block w-6 h-0.5 bg-white transition-all duration-300"
            style={{ opacity: mobileOpen ? 0 : 1 }}
          />
          <span
            className="block w-6 h-0.5 bg-white transition-all duration-300"
            style={{ transform: mobileOpen ? "rotate(-45deg) translateY(-8px)" : "none" }}
          />
        </button>
      </nav>
      {/* Mobile Menu */}
      <div
        className="lg:hidden transition-all duration-500 overflow-hidden"
        style={{
          maxHeight: mobileOpen ? "400px" : "0",
          background: "rgba(15, 31, 61, 0.98)",
          backdropFilter: "blur(20px)",
        }}
      >
        <div className="px-6 pb-8 pt-4 flex flex-col gap-6">
          {navLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="text-white/70 hover:text-white font-semibold text-sm uppercase tracking-widest transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </a>
          ))}
          <div className="flex flex-col gap-3 pt-4 border-t border-white/10">
            <a href="#contact" className="btn-secondary text-center justify-center">
              <span>Book Session</span>
            </a>
            <a href="#membership" className="btn-primary text-center justify-center">
              <span>Join the Revolution</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}